module.exports = __webpack_public_path__ + "img/ebcVnW.a611434b.svg";